import { render, staticRenderFns } from "./InputNewTask.vue?vue&type=template&id=2bb4f728&"
import script from "./InputNewTask.vue?vue&type=script&lang=js&"
export * from "./InputNewTask.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports